<template>
   <BlBackdrop
    title="New curriculum"
    description="Create a new curriculum for targets."
    label="Create"
    :disabled="isDisabledSubmit"
    @backdrop-close="$emit('close-modal')"
    @backdrop-action="onCreate"
  >
    <div class="flex flex-col gap-4 px-8">
      <div class="flex items-center gap-4">
        <BlInputText
          :input="nameInput"
          @changed="inputHandler"
        />
        <div class="relative block flex-shrink-0">
          <label class="mb-1 relative">
            <BlTextBody3 text="Color" />
            <span class="text-error-400 text-xl absolute -top-1 ml-1">*</span>
          </label>
          <div class="relative">
            <div
              :data-id="`color-curriculum`"
              :class="[ colorOpened ? 'border-light-purple' : 'border-slate-500' ]"
              class="relative h-10 w-24 px-4 flex items-center justify-between border rounded cursor-pointer"
              @click.prevent="colorOpened = !colorOpened"
            >
              <div
                class="w-6 h-6 flex-shrink-0 rounded-full"
                :style="{ backgroundColor: colorInput }"
              />
              <BlIcon
                :data-id="`color-curriculum`"
                class="absolute right-4 w-5 h-5 transition-all duration-300"
                icon="chevron-down"
                :style="{ rotate: colorOpened ? '180deg' : '0deg' }"
              />
            </div>
            <div
              :data-id="`color-curriculum`"
              v-if="colorOpened"
              class="absolute right-0 w-54 mt-2 z-10 p-4 bg-pure-white rounded border border-grey-200 shadow-md"
            >
              <div :data-id="`color-curriculum`" class="grid grid-cols-6 flex-wrap gap-2">
                <button
                  :data-id="`color-curriculum`"
                  v-for="item in colorOptions"
                  :key="item.value"
                  class="h-6 w-6 flex-shrink-0 rounded border outline-none"
                  :class="[ colorInput === item.value ? 'border-light-purple' : 'border-transparent' ]"
                  :style="{ backgroundColor: item.value }"
                  @click.prevent="colorInput = item.value"
                  :title="item.label"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <BlInputText
        :input="descriptionInput"
        @changed="inputHandler"
      />
    </div>
   </BlBackdrop>
</template>

<script>
import { mapActions } from "vuex";
import BlBackdrop from "../../BlBackdrop.vue"
import BlIcon from "../../BlIcon.vue";
import BlInputText from "../../BlInputText.vue";
import BlTextBody3 from "../../BlTextBody3.vue";

export default {
  name: "NewCurriculumModal",
  components: { BlBackdrop, BlInputText, BlIcon, BlTextBody3 },
  data() {
    return {
      submitLoading: false,
      nameInput: {
        label: "Name",
        placeholder: "Type the name",
        model: "",
        asterisk: true
      },
      colorOpened: false,
      colorInput: "#A7C957",
      colorOptions: [
        { label: "Green - Moss", value: "#A7C957" },
        { label: "Green - Pear", value: "#D3E4AB" },
        { label: "Red - Salmon", value: "#F4855D" },
        { label: "Red - Coral", value: "#F9B69E" },
        { label: "Yellow - Gold", value: "#F4D430" },
        { label: "Yellow - Daffodil", value: "#FBEEAC" },
        { label: "Green - Lake", value: "#2AB1A8" },
        { label: "Green - Mint", value: "#B8E5E2" },
        { label: "Red - Cherry", value: "#FF4447" },
        { label: "Red - Blush", value: "#FFC1C2" },
        { label: "Yellow - Highlighter", value: "#DCFF00" },
        { label: "Yellow - Butter", value: "#F3FFAA" },
        { label: "Blue - Sky", value: "#487ADF" },
        { label: "Blue - Hydrangeas", value: "#D3DFF7" },
        { label: "Violet - Lavender", value: "#A533FF" },
        { label: "Violet - Lilac", value: "#E1BBFF" },
        { label: "Orange - Tangerine", value: "#F57E00" },
        { label: "Orange - Apricot", value: "#FCD4AA" }
      ],
      descriptionInput: {
        label: "Description",
        placeholder: "Type the description",
        model: "",
        textarea: true
      }
    }
  },
  computed: {
    isDisabledSubmit() {
      if (this.submitLoading) return true;
      // Basic checks
      if (!this.nameInput.model || !this.colorInput) {
        return true;
      }
      return false;
    }
  },
  watch: {
    colorOpened(val) {
      if (val) {
        setTimeout(() => {
          window.addEventListener("click", this.closeHandler);
        }, 10);
      }
    }
  },
  mounted() {
    this.onResetInputs();
  },
  methods: {
    ...mapActions(["createCurriculum"]),
    inputHandler(payload) {
      payload.input.model = payload.value;
    },
    onCreate() {
      const data = {
        name: this.nameInput.model,
        color: this.colorInput,
        description: this.descriptionInput.model
      };
      this.submitLoading = true;
      this.createCurriculum(data).then(({ success }) => {
        this.submitLoading = false;
        if (!success) return;
        this.$emit("close-modal");
      });
    },
    onResetInputs() {
      this.nameInput.model = "";
      this.colorInput = "#A7C957";
      this.descriptionInput.model = "";
    },
    closeHandler(e) {
      let close = true;
      if (e.target && e.target.dataset && e.target.dataset.id) {
        const id = e.target.dataset.id || "";
        if (`color-curriculum` === id) close = false;
      }
      if (close) {
        window.removeEventListener("click", this.closeHandler);
        this.colorOpened = false;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/repository/curricula/NewCurriculumModal.vue